<div class="vctx-editor">
  <!-- Keywords / Listen — the only correction-context input since the
       LLM-corrector removal (2026-08). Fuzzy + phonetic correction consume
       these placeholder lists directly. -->
  <div class="vctx-section">
    <label class="vctx-section-label">
      Keywords / Listen (Default)
      <span class="vctx-section-hint">
        Werte komma- oder zeilenweise (LF/CRLF). Werden von der Fuzzy- und
        Phonetik-Korrektur verwendet.
      </span>
    </label>
    <div *ngFor="let row of placeholders" class="vctx-placeholder-row">
      <div class="vctx-placeholder-name-col">
        <input type="text"
               class="clr-input vctx-placeholder-name"
               [(ngModel)]="row.name"
               [disabled]="saving"
               placeholder="name" />
        <span *ngIf="validatePlaceholderName(row.name) as warn" class="vctx-name-warn">{{ warn }}</span>
      </div>
      <textarea class="clr-textarea vctx-placeholder-csv"
                rows="2"
                [(ngModel)]="row.csv"
                [disabled]="saving"
                placeholder="Wert1, Wert2, Wert3  —  oder zeilenweise (LF/CRLF)"></textarea>
      <button type="button" class="btn btn-sm btn-icon vctx-placeholder-remove"
              (click)="removePlaceholderByRow(row)"
              [disabled]="saving"
              title="Liste entfernen">
        <cds-icon shape="trash" size="14"></cds-icon>
      </button>
    </div>
    <button type="button" class="btn btn-sm btn-link vctx-add-placeholder"
            (click)="addPlaceholder()"
            [disabled]="saving">
      <cds-icon shape="plus-circle" size="14"></cds-icon>
      Liste hinzufügen
    </button>
  </div>

  <!-- Messages -->
  <div *ngIf="errorMessage" class="vctx-message vctx-message-error">{{ errorMessage }}</div>
  <div *ngIf="infoMessage" class="vctx-message vctx-message-info">{{ infoMessage }}</div>
  <div *ngIf="successMessage" class="vctx-message vctx-message-success">{{ successMessage }}</div>

  <!-- Actions row -->
  <div class="vctx-actions">
    <button type="button" class="btn btn-sm btn-primary"
            (click)="onApplyToBroadcast()"
            [disabled]="saving">
      {{ saving ? 'Übernehme…' : 'Für Sendung übernehmen' }}
    </button>
  </div>
</div>
